import ReactDOM from 'react-dom'
import { getProcodocsRequests } from '../../../../../lib/fetchApi'
import classes from './RequestsMain.module.css'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Button from '../../../../common/Button'
import CreateRequest from './CreateRequest'
import RequestListItem from './RequestListItem'
import RequestDetails from './RequestDetails'
import { notificationActions } from '../../../../../store/notifications'
import { useDispatch } from 'react-redux'
import { isManagingAttorney } from '../../../../../lib/primaryItemScripts'
import Backdrop from '../../../../common/modal/Backdrop'
import Modal from '../../../../common/Modal'
import ModalInnerWrapper from '../../../../common/ModalInnerWrapper'
import { caseActions } from '../../../../../store/case'


export default function RequestsMain({ activeCase: propActiveCase }) {
    const dispatch = useDispatch()
    const currentRequests = useSelector(state => state.case.currentRequests)
    const userToken = useSelector(state => state.user.token)
    const storeCase = useSelector(state => state.case.activeCase)
    const activeCase = propActiveCase ?? storeCase
    const caseId = activeCase?.case?.id
    const [loading, setLoading] = useState(false)
    const [createRequestLoading, setCreateRequestLoading] = useState(false)
    const [showCreateRequest, setShowCreateRequest] = useState(false)
    const [showRequestsExpanded, setShowRequestsExpanded] = useState(false)
    const [requestDetails, setRequestDetails] = useState(null)

    const selectedProcoDocsAttorney = useSelector(state => state.attorney.selectedProcoDocsAttorney)

    const fetchRequests = async (awaitRefresh) => {
        if (!caseId) {
            return
        }

        let previousRequestDetails = requestDetails?.id

        setRequestDetails(null)
        setLoading(true)
        const requests = await getProcodocsRequests(userToken, caseId, selectedProcoDocsAttorney ? selectedProcoDocsAttorney : isManagingAttorney(activeCase)?.id)
        if (requests && requests.errorMessage) {
            dispatch(notificationActions.setError(requests))
        } else {
            dispatch(caseActions.setCurrentRequests(requests))
            setLoading(false)
            if (previousRequestDetails) {
                setRequestDetails(requests.find(request => request.id === previousRequestDetails))
            }
            if (awaitRefresh) {     
                setRequestDetails(requests[0])
            }
        }
        
    }
    const showCreateRequestHandler = () => {
        if (showCreateRequest) {
            setShowCreateRequest(false)
            return
        }
        setShowCreateRequest(true)
    }
    const closeCreateRequestHandler = async () => {
        setShowCreateRequest(false)
        // fetchRequests()
    }

    function closeCreateRequestHandlerAndOpenList() {
        fetchRequests(true)
        setShowRequestsExpanded(true)
        setShowCreateRequest(false)
    }

    function showRequestsExpandedHandler(request) {
        setShowRequestsExpanded(true)
        setRequestDetails(request)
    }

    function closeRequestsExpandedHandler() {
        setShowRequestsExpanded(false)
        setRequestDetails(null)
    }

    function viewAllRequestsHandler() {
        setShowRequestsExpanded(true)
        setRequestDetails(currentRequests[0])
    }


    useEffect(() => {
        fetchRequests()
    }, [selectedProcoDocsAttorney, caseId])


    return <div>
        <div className={`${classes.container} ${showRequestsExpanded ? classes.expanded : ''}`}>
            <div className={classes.header}>
                <h3>Notes</h3>
                <div className={classes.header_buttons}>
                    <Button title='Refresh' btnStyle='btn_small' click={fetchRequests} isLoading={loading} ><i className='ti ti-refresh'></i></Button>
                    <Button title={!showCreateRequest ? 'Create Note' : 'Close'} btnStyle='btn_small' click={showCreateRequestHandler} isLoading={createRequestLoading}>
                        {!showCreateRequest ? <i className='ti ti-plus'></i> : <i className='ti ti-x'></i>}
                    </Button>
                    {showRequestsExpanded && <Button title='Close' btnStyle='btn_small' click={closeRequestsExpandedHandler}><i className='ti ti-x'></i></Button>}
                </div>
            </div>
            <div className={`${classes.body} ${showRequestsExpanded ? classes.body_expanded : ''}`}>
                {!showCreateRequest && <div className={`${classes.request_list_container} ${showRequestsExpanded ? classes.request_list_container_expanded : ''}`}>
                    <div className={classes.request_list_wrapper}>
                        <div className={classes.request_list}>
                            {currentRequests && currentRequests.length > 0 && currentRequests.filter(request => !showRequestsExpanded ? !request.is_resolved : true).map(request => (
                                <RequestListItem key={request.id} data={request} showRequestsExpanded={showRequestsExpandedHandler} activeRequest={requestDetails?.id} />
                            ))}
                        </div>                    
                    </div>
                    {showRequestsExpanded && requestDetails &&  <RequestDetails request={requestDetails} refreshRequests={fetchRequests} />}
                </div>}
                {/* {showCreateRequest && <CreateRequest closeModal={closeCreateRequestHandler} />} */}
            </div>
            
        </div>

        {!showRequestsExpanded && currentRequests && currentRequests.length > 0 && <div className={classes.container_footer}>
            <Button title='View All Notes' btnStyle='btn_small' click={viewAllRequestsHandler}>View All {currentRequests.length} {currentRequests.length == 1 ? 'Note' : 'Notes'} ({currentRequests.filter(request => request.is_resolved).length} Resolved, {currentRequests.filter(request => !request.is_resolved).length} Unresolved)</Button>
        </div>}



        {showCreateRequest && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeCreateRequestHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeCreateRequestHandler} modalTitle={'Create Note'}>
                        <CreateRequest closeModal={closeCreateRequestHandler} closeModalAndOpenList={closeCreateRequestHandlerAndOpenList} />
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </div>
}